import { render, staticRenderFns } from "./StudyResultsProjectionsDrawer.vue?vue&type=template&id=10b0e514&scoped=true&"
import script from "./StudyResultsProjectionsDrawer.vue?vue&type=script&lang=js&"
export * from "./StudyResultsProjectionsDrawer.vue?vue&type=script&lang=js&"
import style0 from "./StudyResultsProjectionsDrawer.vue?vue&type=style&index=0&id=10b0e514&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b0e514",
  null
  
)

export default component.exports